export default __webpack_public_path__ + "static/media/pricing-category-icon.4d300c25.svg";